import { render, staticRenderFns } from "./UserSettingsApiKeyPage.vue?vue&type=template&id=0307cc09&"
import script from "./UserSettingsApiKeyPage.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsApiKeyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
